module.exports = __webpack_public_path__ + "static/media/strong.92835469.PNG";